import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs } from 'antd';
import FunnelAnalyses from './FunnelAnalyses';
import Dimensions from './Dimensions';
import Events from './Events';
import * as Styles from './styled';

const QUERY_KEY = 'asset';
const DEFAULT_TAB = 'events';

const TAB_ITEMS = [
  {
    key: 'events',
    label: 'Critical Events',
    children: <Events />,
  },
  {
    key: 'dimensions',
    label: 'Dimensions',
    children: <Dimensions />,
  },
  {
    key: 'funnel-analyses',
    label: 'Funnel Analyses',
    children: <FunnelAnalyses />,
  },
];

const ManagementList = () => {
  const [searchParams, setSearchParams] = useSearchParams({ [QUERY_KEY]: DEFAULT_TAB });

  return (
    <Styles.ManagementContent>
      <Tabs
        activeKey={searchParams.get(QUERY_KEY) ?? DEFAULT_TAB}
        items={TAB_ITEMS}
        onChange={(key) => setSearchParams({ [QUERY_KEY]: key })}
      />
    </Styles.ManagementContent>
  );
};

export default React.memo(ManagementList);
